import React from "react";
import { Grid, Typography, Paper, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CommonButton from "../../Components/InputComponents/CommonButton";
import { useClientLayout } from "../../Components/Context/CandidateLayoutContext";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const ClientProfilePortal = () => {
  const navigate = useNavigate();
  const { clientData } = useClientLayout();

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        padding: 2,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          mb: 2,
          gap: 2,
        }}
      >
        <CommonButton
          variant="contained"
          background="#006CB8"
          onClick={() => navigate("/")}
           margin="0px 20px 10px 0px"
        >
          <ArrowBackIcon sx={{ color: "white" }} />
        </CommonButton>

        <Typography
          variant="h5"
          sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
        >
          Profile
        </Typography>
      </Box>

      {/* Basic Information Section */}
      <Box
        sx={{
          border: "1px solid lightgrey",
          p: 3,
          borderRadius: "20px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            borderRadius: 2,
            px: 2,
            py: 1,
            mb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
          >
            Basic Information
          </Typography>
        </Box>

        <Grid container spacing={2}>
          {[
            { label: "Name", value: clientData?.CD_Name },
            { label: "Email", value: clientData?.CD_Email },
            { label: "Contact Number", value: clientData?.CD_Phone },
            { label: "Address", value: clientData?.CD_Address },
            { label: "Country", value: clientData?.CD_CountryName },
            { label: "Company Type", value: clientData?.CD_CompanyTypeName },
          ].map((item, index) => (
            <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontFamily: "Geist, sans-serif",
                    fontSize: "18px",
                    mb: 0.5,
                  }}
                >
                  {item.label}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontFamily: "Geist, sans-serif",
                    fontSize: "16px",
                  }}
                >
                  {item.value || "—"}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Paper>
  );
};

export default ClientProfilePortal;
